import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

export const ImageCrop = (p: ReactCrop.ReactCropProps) => {
  return <ReactCrop {...p} />;
};

export const cropImage = (image: HTMLImageElement, crop: ReactCrop.Crop) => {
  const { width = 0, height = 0, x = 0, y = 0 } = crop;
  const canvas = document.createElement('canvas');
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;
  const ctx = canvas.getContext('2d');

  if (!ctx) {
    throw new Error('CANNOT_CREATE_CANVAS');
  }

  // This might be useful for retina style screens?
  // const pixelRatio = window.devicePixelRatio;
  const pixelRatio = 1;
  canvas.width = width;
  canvas.height = height;
  canvas.width = scaleX * width * pixelRatio;
  canvas.height = scaleY * height * pixelRatio;

  ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
  ctx.imageSmoothingQuality = 'high';

  ctx.drawImage(
    image,
    x * scaleX,
    y * scaleY,
    width * scaleX,
    height * scaleY,
    0,
    0,
    width * scaleX,
    height * scaleY
  );

  console.log('canvas', canvas.width, canvas.height);

  return new Promise<Blob>((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject('CANNOT_CREATE_BLOB');
          return;
        }
        resolve(blob);
      },
      'image/png',
      1
    );
  });
};

export const cropImageFromDataURL = (dataURL: string, crop: ReactCrop.Crop) => {
  return new Promise<Blob>((resolve, reject) => {
    const image = document.createElement('img');
    image.src = dataURL;
    image.onload = () => {
      cropImage(image, crop).then(resolve, reject);
    };
  });
};
